import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import Grid from "@mui/material/Grid";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Typography } from "@mui/material";

import House from "@mui/icons-material/HouseTwoTone";
import Hotel from "@mui/icons-material/HotelTwoTone";
import HomeWork from "@mui/icons-material/HomeWorkTwoTone";
import colors from "../style/color";

const icons = {
  House,
  Hotel,
  HomeWork,
};

export default function RadioButtonGroup(props) {
  const [value, setValue] = useState(null);

  const toggleButtonStyle = {
    width: "100%",
    position: "relative", // for positioning info icon
  };

  const toggleButtonContentStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    color: colors.black,
    fontWeight: 600,
    lineHeight: 1.2,
  };

  useEffect(() => {
    if (props.livingArrangements) setValue(props.livingArrangements);
  }, []);

  return (
    <>
      <Grid container spacing={1} style={{ paddingTop: 0 }} direction="column" id={props.id}>
        <ToggleButtonGroup
          exclusive
          value={value}
          onChange={(event, newValue) => {
            if (newValue) {
              setValue(newValue);
              props.handleValue(newValue);
            }
          }}
          style={{ border: value ? "" : "1px solid #d32f2f" }}
        >
          {props?.options?.map((option) => {
            const Icon = icons[option.icon];
            return (
              <ToggleButton
                key={nanoid()}
                value={option.label}
                selected={value === option.label}
                style={toggleButtonStyle}
              >
                {/* Info Icon (top-right corner) */}
                {option?.info && (
                <Tooltip title={option.info || "More info"}>
                  <IconButton
                    size="small"
                    style={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      padding: 2,
                      color: colors.primary
                    }}
                  >
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                )}

                {/* Icon + Label */}
                <div style={toggleButtonContentStyle}>
                  {option.icon && <Icon />}
                  <p
                    style={{
                      textTransform: "none",
                      letterSpacing: 0,
                      margin: "5px 0 0",
                    }}
                  >
                    {option.label}
                  </p>
                </div>
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>

        {!value && (
          <Typography
            variant="caption"
            style={{ color: "#d32f2f", margin: "3px 0 0 7px" }}
          >
            Required
          </Typography>
        )}
      </Grid>
    </>
  );
}
